import axios from "axios"
import * as actions from "../actions/candidate"

import { formatDatetimeLocal } from '../js/utils'

function buildFormDataFromCandidate(candidate) {
  // create FormData object to send as request instead of normal json data
  // this will make the request multipart and will split each parameter with a boundary
  // multipart is needed when uploading a file
  let data = new FormData()
  let candidatePropertyNames = Object.keys(candidate)
  for (let i = 0; i < candidatePropertyNames.length; i++) {
    let candidatePropertyName = candidatePropertyNames[i]
    let propertyValue = candidate[candidatePropertyName]
    if (propertyValue) {
      if (candidatePropertyName === 'GenderLookup' || candidatePropertyName === 'SkillLookups' || candidatePropertyName === 'QualificationLookups' || candidatePropertyName === 'CandidateBoards') {
        // stringfiy lookup since it is an object so we can deserialise into an object server side
        // otherwise it will be sent as [object Object]
        data.append(candidatePropertyName, JSON.stringify(propertyValue))
      } else if (candidatePropertyName === 'DateOfBirth') {
        // need to format date to string here to make sure it doesn't get converted to UTC
        // this done here since when using FormData it won't hit the part in the axios interceptor that would normally handle this
        let formattedDate = formatDatetimeLocal(propertyValue)
        data.append(candidatePropertyName, formattedDate)
      } else {
        data.append(candidatePropertyName, propertyValue)
      }
    }
  }
  return data
}

export function addCandidate(candidate) {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      let data = candidate
      let url = process.env.REACT_APP_API_HOST + "/api/candidate"

      // if uploading file then build up FormData to send as multipart/form-data
      if (candidate.CandidateCv) {
        data = buildFormDataFromCandidate(candidate)
        url = process.env.REACT_APP_API_HOST + "/api/candidate/with-cv"
      }
      axios.post(url, data)
        .then(response => {
          if (response && response.data.Success) {
            dispatch(actions.getCandidate(response.data.SuccessOutput))
          }
          resolve(response)
        })
        .catch(error => reject(error))
    })
  }
}

export function updateCandidate(candidate) {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      let data = candidate
      let url = process.env.REACT_APP_API_HOST + "/api/candidate"

      // convert date of birth to date so we handle correctly for things such as UTC and format
      candidate.DateOfBirth = candidate.DateOfBirth ? new Date(candidate.DateOfBirth) : null

      // if uploading file then build up FormData to send as multipart/form-data
      if (candidate.CandidateCv) {
        data = buildFormDataFromCandidate(candidate)
        url = process.env.REACT_APP_API_HOST + "/api/candidate/with-cv"
      }
      axios.put(url, data)
        .then(response => {
          if (response && response.data.Success) {
            dispatch(actions.getCandidate(response.data.SuccessOutput))
          }
          resolve(response)
        })
        .catch(error => reject(error))
    })
  }
}

export function getCandidate(candidateId) {
  return (dispatch) => {
    return axios.get(process.env.REACT_APP_API_HOST + "/api/candidate/" + candidateId)
      .then(response => { 
        let candidate = response ? response.data : {}
        dispatch(actions.getCandidate(candidate))
      })
  }
}

export function getCandidates() {
  return (dispatch) => {
    return axios.get(process.env.REACT_APP_API_HOST + "/api/candidate")
      .then((response) => {
        let candidates = response && response.data ? response.data.$values : []
        dispatch(actions.getCandidates(candidates))
      })
  }
}

export function getCandidateListItems() {
  return (dispatch) => {
    return axios.get(`${process.env.REACT_APP_API_HOST}/api/candidate/list`)
      .then((response) => {
        let candidateListItems = response && response.data ? response.data.$values : []
        dispatch(actions.getCandidateListItems(candidateListItems))
      })
  }
}

export function getCandidatesDetails(candidateIds) {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      axios.post(`${process.env.REACT_APP_API_HOST}/api/candidate/details`, candidateIds)
        .then(response => {
          resolve(response)
        })
        .catch(error => reject(error))
    })
  }
}

export function getRejectReasonCandidate(candidateId) {
  return (dispatch) => {
    return axios.get(`${process.env.REACT_APP_API_HOST}/api/candidate/${candidateId}/reject-reason`)
      .then((response) => {        
        let rejectReason = response ? response.data : {}
        dispatch(actions.getRejectReason(rejectReason))
      })
  }
}

export function rejectCandidate(rejectReason) {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      axios.put(`${process.env.REACT_APP_API_HOST}/api/candidate/${rejectReason.CandidateId}/reject`, rejectReason)
        .then(response => {
          if (response && response.data.Success) {
            // update store with lobbyist view model returned from the server
            dispatch(actions.getCandidate(response.data.SuccessOutput))
          }
          resolve(response)
        })
        .catch(error => reject(error))
    })
  }
}

export function withdrawCandidate(candidateId) {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      axios.put(`${process.env.REACT_APP_API_HOST}/api/candidate/${candidateId}/withdraw`)
        .then(response => {
          if (response && response.data.Success) {
            // update store with candidate view model returned from the server
            dispatch(actions.getCandidate(response.data.SuccessOutput))
          }
          resolve(response)
        })
        .catch(error => reject(error))
    })
  }
}

export function deleteCandidate(candidateId) {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      axios.put(`${process.env.REACT_APP_API_HOST}/api/candidate/${candidateId}/delete`)
        .then(response => {
          if (response && response.data.Success) {
            // update store with candidate view model returned from the server
            //dispatch(actions.getCandidate(response.data.SuccessOutput))
          }
          resolve(response)
        })
        .catch(error => reject(error))
    })
  }
}

export function reactivateCandidate(candidateId) {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      axios.put(`${process.env.REACT_APP_API_HOST}/api/candidate/${candidateId}/reactivate`)
        .then(response => {
          if (response && response.data.Success) {
            // update store with candidate view model returned from the server
            dispatch(actions.getCandidate(response.data.SuccessOutput))
          }
          resolve(response)
        })
        .catch(error => reject(error))
    })
  }
}

export function removeCandidateCv(candidateId) {
  return (dispatch) => {
    return axios.post(process.env.REACT_APP_API_HOST + "/api/candidate/" + candidateId + "/remove-cv")
    .then((response) => {
      if (response && response.data.Success) {
        // update store with candidate view model returned from the server
        dispatch(actions.getCandidate(response.data.SuccessOutput))
      }    
    })
  }
}

export function exportToExcel(candidateIds) {
  return (dispatch) => {
    return axios.post(process.env.REACT_APP_API_HOST + "/api/candidate/export-excel", candidateIds, {
      // VERY IMPORTANT - none of the files that get returned will open correctly without this
      responseType: 'blob'
    })
  }
}

export function exportToPdf(candidateIds) {
  return (dispatch) => {
    return axios.post(process.env.REACT_APP_API_HOST + "/api/candidate/export-pdf", candidateIds, {
    })
  }
}

export function getCandidateCv(candidateId) {
  return (dispatch) => {
    return axios.get(process.env.REACT_APP_API_HOST + "/api/candidate/" + candidateId + "/cv", {
      // VERY IMPORTANT - none of the files that get returned will open correctly without this
      responseType: 'blob'
    })
  }
}




// WEBPACK FOOTER //
// ./src/actionCreators/candidate.js